<template>
	<div>
		<v-data-table
			:headers="header"
			:items="items"
			:footer-props="footer"
			:hide-default-footer="items.length <= 10"
			:page.sync="page"
			hide-default-header
			class="cursor-pointer"
			@click:row="goToItem"
		>
			<template #[`item.moveType`]="{ item }">
				<span
					v-for="i in parseType(item)"
					:key="i"
					class="move-type"
					v-text="i"
				/>
			</template>

			<template #[`item.CreatedDate`]="{ value }">
				{{ parseDate(value) }}
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			header: [
				{ value: "resident" },
				{ value: "moveType" },
				{ value: "community" },
				{ value: "CreatedDate" },
			],
			footer: {
				showCurrentPage: true,
				disableItemsPerPage: true,
				itemsPerPageOptions: [],
				itemsPerPageText: "",
			},
			page: 1,
		};
	},

	computed: {
		...mapGetters("tickets/roomMoves", ["items"]),
	},

	watch: {
		page(page) {
			// eslint-disable-next-line eqeqeq
			if (page != this.$route.query.page)
				this.$router.replace({ name: this.$route.name, query: { page }});
		}
	},

	async created() {
		// Refetchs items when it's a new navigation to the NOC
		// The page query resets when we route out of room moves
		await this.getItems(!this.$route.query.page);
		const page = this.$route.query.page;
		if (page) this.page = Number(page);
	},

	methods: {
		...mapActions("tickets/roomMoves", ["getItems"]),
		...mapMutations({ setCurrent: "tickets/roomMoves/SET_CURRENT" }),

		parseType({ moveType, currentAddress, newAddress }) {
			const result = [moveType];

			if (moveType === "Move") {
				result.push(`(${currentAddress} - ${newAddress})`);
			} else {
				result.push(`(${currentAddress || newAddress})`);
			}

			return result;
		},

		parseDate(date) {
			return new Date(date).toDateString();
		},

		goToItem(item) {
			this.setCurrent(item);
			this.$router.push({ path: item.Id, append: true });
		},
	},
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
	cursor: pointer;
}

.move-type {
	&:nth-of-type(1)::after {
		content: " ";
	}
	&:nth-of-type(2) {
		font-weight: 500;
	}
}
</style>
